<template>
  <div>
    <el-dialog
      :title="this.isCreated ? '新增返利区间配置' : '编辑返利区间配置'"
      center
      :visible="true"
      @close="onClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="701px"
    >
      <el-form
        ref="form"
        :model="form"
        label-width="120px"
        size="mini"
        style="margin-right: 50px"
      >
        <el-form-item label="返利区间(元)：" prop="range">
          <el-input
            placeholder="最小金额"
            style="width: 150px"
            v-model="form.range[0]"
          ></el-input>
          -
          <el-input
            placeholder="最大金额"
            style="width: 150px"
            v-model="form.range[1]"
          ></el-input>
        </el-form-item>
        <el-form-item label="返利倍率：">
          <el-input
            placeholder="比如0.1"
            style="width: 80px"
            v-model="form.rebateRatio"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="this.onClose">取消</el-button>
        <el-button type="primary" @click="submit()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
const util = require("@/util");
import BaseItemSelector from "../biz-components/BaseItemSelector";

// 本弹窗名称
const DialogName = "EditRechargeRebateDialog";
export default {
  data() {
    return {
      form: {
        range: ["", ""],
        rebateRatio: "",
      },
      isCreated: false,
      itemSelectorResult: [],
    };
  },

  computed: {},

  async created() {
    let value = this.$dialogutil.getData(DialogName);
    if (value.entry != null) {
      this.form = value.entry;
    }
    this.isCreated = value.isCreated;
  },
  components: {
    BaseItemSelector,
  },

  methods: {
    /**
     * 编辑线上活动
     * @param {*} entry
     */
    async submit() {
      if (this.isCreated) {
        await this.add();
      } else {
        await this.update();
      }
    },

    async add() {
      try {
        // 弹确认框
        await this.$confirm(
          `确认新增（该操作不会真的保存配置，需要在上一级页面中保存）？`
        );

        let param = this.save();
        if (param.errMsg) {
          this.$message({
            message: param.errMsg,
            type: "error",
          });
          return;
        }
        this.$message({
          message: "新增成功",
          type: "success",
        });

        // 关闭当前对话框
        this.onCloseWhitParam(param);
      } catch (e) {}
    },
    async update() {
      try {
        // 弹确认框
        await this.$confirm(
          `确认修改（该操作不会真的保存配置，需要在上一级页面中保存）？`
        );

        let param = this.save();

        if (param.errMsg) {
          this.$message({
            message: param.errMsg,
            type: "error",
          });
          return;
        }
        this.$message({
          message: "修改成功",
          type: "success",
        });

        // 关闭当前对话框
        this.onCloseWhitParam(param);
      } catch (e) {}
    },

    save() {
      if (isNaN(this.form.range[0]) || !this.form.range[0].toString().trim()) {
        return { errMsg: "最小金额必须是一个数值" };
      }
      let fromRange = Number(this.form.range[0]);
      if (fromRange <= 0) {
        return { errMsg: "最小金额必须大于0" };
      }

      if (isNaN(this.form.range[1]) || !this.form.range[1].toString().trim()) {
        return { errMsg: "最大金额必须是一个数值" };
      }
      let toRange = Number(this.form.range[1]);
      if (toRange <= 0) {
        return { errMsg: "最大金额必须大于0" };
      }

      if (fromRange >= toRange) {
        return { errMsg: "最小金额不能大于等于最大金额" };
      }

      if (
        isNaN(this.form.rebateRatio) ||
        !this.form.rebateRatio.toString().trim()
      ) {
        return { errMsg: "返利倍率必须是一个数值" };
      }
      let rebateRatio = Number(this.form.rebateRatio);
      if (rebateRatio <= 0) {
        return { errMsg: "返利倍率必须大于0" };
      }

      return {
        range: [fromRange, toRange],
        rebateRatio: rebateRatio,
      };
    },

    async updatedItemSelector(param) {
      this.itemSelectorResult = param;
    },

    ms2ymdhm(ts) {
      return util.ms2ymdhm(ts);
    },

    onClose() {
      // 关闭当前对话框
      this.$dialogutil.close(DialogName);
    },
    onCloseWhitParam(param) {
      // 关闭当前对话框
      this.$dialogutil.close(DialogName, param);
    },
  },
};
</script>

<style lang="scss" scoped>
.switch-status-tag {
  display: inline-block;
  padding: 0 10px;
  border: 1px solid #d9ecff;
  border-radius: 4px;
}
.switch-status-tag-off {
  background-color: lightgray;
  border-color: lightgray;
}
.switch-status-tag-on {
  background-color: chartreuse;
  border-color: chartreuse;
}
</style>

